export const SENDING_METHODS = {
  EGIFT: 'send_egift',
  PHYSICAL: 'send_physical_gift'
};

export const ADDRESS_TYPES = {
  HOME: 'home',
  WORK: 'work'
};

export const AVAILABLE_SENDING_METHODS = [
  { id: SENDING_METHODS.EGIFT, name: 'eGift (via email/link)' },
  { id: SENDING_METHODS.PHYSICAL, name: 'Gift (send to address)' }
];

export const AVAILABLE_ADDRESS_TYPES = [
  { id: ADDRESS_TYPES.HOME, name: 'Home address' },
  { id: ADDRESS_TYPES.WORK, name: 'Work address' }
];
